<cb-dialog dialogHeading="Review Pre-Consent" *cbWaitFor="mappedItem">
    <form #form="ngForm">
        <div class="cb-margin flex-row">
            <div class="flex-col flex-40">
                <span class="cb-title">{{ getHeading() }}</span>
                <cb-display-value-new
                    label="Status"
                    [value]="mappedItem?.preConsentPlanStatus?.label"
                ></cb-display-value-new>
                <div class="flex-col">
                    <div class="flex-row flex">
                        <cb-display-value-new class="flex-50" label="Land Area">
                            <div class="start-center">
                                <mat-icon class="cb-grey">border_style</mat-icon>
                                <span class="mat-body-2"
                                    >&nbsp;{{
                                        lotMappedItem?.amenities?.landArea | cbDasher
                                    }}m²</span
                                >
                            </div>
                        </cb-display-value-new>
                        <cb-display-value-new class="flex-50" label="Floor Area">
                            <div class="start-center">
                                <mat-icon svgIcon="floor-plan"></mat-icon>
                                <span class="mat-body-2"
                                    >&nbsp;{{
                                        lotMappedItem?.amenities?.floorArea | cbDasher
                                    }}m²</span
                                >
                            </div>
                        </cb-display-value-new>
                    </div>
                    <div class="flex-row flex">
                        <cb-display-value-new class="flex-50" label="Bedroom">
                            <div class="start-center">
                                <mat-icon>hotel</mat-icon>
                                <span class="mat-body-2"
                                    >&nbsp;{{
                                        lotMappedItem?.amenities?.noBedrooms | cbDasher
                                    }}</span
                                >
                            </div>
                        </cb-display-value-new>
                        <cb-display-value-new class="flex-50" label="Bathroom">
                            <div class="start-center">
                                <mat-icon>wc</mat-icon>
                                <span class="mat-body-2"
                                    >&nbsp;{{
                                        lotMappedItem?.amenities?.noBathrooms | cbDasher
                                    }}</span
                                >
                            </div>
                        </cb-display-value-new>
                    </div>
                    <div class="flex-row flex">
                        <cb-display-value-new class="flex-50" label="Living">
                            <div class="start-center">
                                <mat-icon>weekend</mat-icon>
                                <span class="mat-body-2"
                                    >&nbsp;{{
                                        lotMappedItem?.amenities?.noLivingRooms | cbDasher
                                    }}</span
                                >
                            </div>
                        </cb-display-value-new>
                        <cb-display-value-new class="flex-50" label="Garage">
                            <div class="start-center">
                                <mat-icon>directions_car</mat-icon>
                                <span class="mat-body-2"
                                    >&nbsp;{{
                                        lotMappedItem?.amenities?.noGarages | cbDasher
                                    }}</span
                                >
                            </div>
                        </cb-display-value-new>
                    </div>
                </div>
            </div>
            <div class="cb-complete-design-scheme-dialog-right-panel flex-col flex-60">
                <span class="mat-body-strong">Items & Changes</span>
                <div
                    class="cb-margin flex-col"
                    style="border: 1px solid #f0f0f0; border-radius: 2px"
                >
                    @if (mappedItem.items?.length > 0) {
                        @for (item of mappedItem.items; track item) {
                            <div class="flex-col">
                                <div class="cb-margin-top cb-margin-bottom start-start flex-row">
                                    <span class="mat-body-strong cb-margin-left-2x"
                                        >Item #{{ item.id }}</span
                                    >
                                    <div class="cb-margin-left-2x flex-col flex mat-body-2">
                                        <div
                                            style="white-space: pre-line"
                                            class="force-wrap flex-col flex"
                                        >
                                            {{ item.description }}
                                        </div>
                                        @if (item.comments?.length > 0) {
                                            <div class="start-start flex-row">
                                                <div
                                                    class="center-center flex-row"
                                                    style="margin-top: 18px; margin-right: 10px"
                                                >
                                                    <mat-icon>message</mat-icon>
                                                </div>
                                                <cb-text-area
                                                    name="{{ item.id }}_requirementComments"
                                                    [(ngModel)]="item.comments"
                                                    [maxlength]="1024"
                                                    [readonly]="true"
                                                ></cb-text-area>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                        }
                    }
                </div>
                <span class="mat-body-strong">Pre-Consent Documents for Review</span>
                <cb-document
                    *cbWaitFor="mappedItem && DESIGN_PRE_CONSENT_GROUP"
                    [entity]="mappedItem"
                    [permissions]="getDocumentPermissions()"
                    [hideDeletedToggle]="true"
                    [hideUploadButton]="true"
                    [hideSearch]="true"
                    [edit]="false"
                    [documentGroupCode]="DESIGN_PRE_CONSENT_GROUP"
                    [systemArea]="systemArea"
                    style="margin: -8px"
                ></cb-document>
            </div>
        </div>
    </form>
    <div actions>
        <button mat-raised-button color="primary" (cbClick)="acceptPreConsentPlan()">
            Accept Pre-Consent
        </button>
        <button mat-raised-button color="warn" (cbClick)="rejectPreConsentPlan()">
            Reject Pre-Consent
        </button>
        <button mat-raised-button (click)="cancel()">Close</button>
    </div>
</cb-dialog>
